__turbopack_context__.v({
  "container": "ButtonTooltip-module-scss-module__8TS2VW__container",
});
